enum AnnouncementFormType {
  message,
  startDate,
  endDate,
  isNonWorkingDay,
}

export default AnnouncementFormType;
